export const decodeText = (text: string) => {
  let updatedText = text
  updatedText = updatedText.replace(/[\u2018\u2019\u201A]/g, "'")
  // smart double quotes
  updatedText = updatedText.replace(/[\u201C\u201D\u201E]/g, '"')
  // ellipsis
  updatedText = updatedText.replace(/\u2026/g, '...')
  // dashes
  updatedText = updatedText.replace(/[\u2013\u2014]/g, '-')
  // circumflex
  updatedText = updatedText.replace(/\u02C6/g, '^')
  // open angle bracket
  updatedText = updatedText.replace(/\u2039/g, '<')
  // close angle bracket
  updatedText = updatedText.replace(/\u203A/g, '>')
  // spaces
  updatedText = updatedText.replace(/[\u02DC\u00A0]/g, ' ')
  // Guillemet or french quote character
  // https://en.wikipedia.org/wiki/Guillemet
  updatedText = updatedText.replace(/[\u00AB]/g, '<')
  updatedText = updatedText.replace(/[\u00BB]/g, '>')

  return updatedText
}
